module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 49);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@andes/common");

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(50);


/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Modal = __webpack_require__(51);

module.exports = Modal;

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global document */
/**
 * Module dependencies
 */
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var classNames = __webpack_require__(2);

var _require = __webpack_require__(3),
    Portal = _require.Portal;

var Actions = __webpack_require__(52);
var Header = __webpack_require__(53);
var Content = __webpack_require__(54);
var CloseButton = __webpack_require__(8);
var urlNavigation = __webpack_require__(57);

/**
 * Components
 */

var Modal = function (_React$PureComponent) {
  _inherits(Modal, _React$PureComponent);

  function Modal(props) {
    _classCallCheck(this, Modal);

    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this.state = {
      visible: props.visible,
      scrolled: false,
      actionsShadow: true,
      paddingTop: 0,
      height: '100%',
      closing: false
    };

    _this.navigation = _this.navigation.bind(_this);
    _this.setModal = _this.setModal.bind(_this);
    _this.setBg = _this.setBg.bind(_this);
    _this.setHeader = _this.setHeader.bind(_this);
    _this.setActions = _this.setActions.bind(_this);
    _this.onClose = _this.onClose.bind(_this);
    _this.handleHeaderIntersection = _this.handleHeaderIntersection.bind(_this);
    _this.handleActionsIntersection = _this.handleActionsIntersection.bind(_this);
    _this.pressEscToClose = _this.pressEscToClose.bind(_this);
    return _this;
  }

  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('keydown', this.pressEscToClose, false);
      urlNavigation.addChange(this.navigation);
      this.handleOpen();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.state.visible !== nextProps.visible) {
        this.setState({
          visible: nextProps.visible,
          title: nextProps.title
        }, function () {
          if (nextProps.visible && nextProps.onOpen) {
            nextProps.onOpen();
          } else if (!nextProps.visible && nextProps.onClose) {
            nextProps.onClose();
          }
          _this2.handleOpen();
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.pressEscToClose, false);
      urlNavigation.removeChange(this.navigation);
    }
  }, {
    key: 'onClose',
    value: function onClose(event) {
      var _this3 = this;

      if (event) {
        event.preventDefault();
        if (event.persist) {
          event.persist();
        }
      }
      this.setState({
        closing: true
      });
      this.close(function () {
        if (_this3.props.onClose) {
          _this3.props.onClose(event);
        }
        _this3.handleOpen();
      });
    }
  }, {
    key: 'setModal',
    value: function setModal(modal) {
      this.modal = modal;
    }
  }, {
    key: 'setBg',
    value: function setBg(bg) {
      this.bg = bg;
    }
  }, {
    key: 'setHeader',
    value: function setHeader(header) {
      this.headerHeight = header ? header.header.clientHeight : 0;
    }
  }, {
    key: 'setActions',
    value: function setActions(actions) {
      this.actionsHeight = actions ? actions.actions.clientHeight : 0;
    }
  }, {
    key: 'close',
    value: function close(onClose) {
      var _this4 = this;

      setTimeout(function () {
        _this4.setState({
          visible: false,
          closing: false
        }, onClose);
      }, 180);
    }
  }, {
    key: 'navigation',
    value: function navigation() {
      if (urlNavigation.isLocationURL(this.props.url)) {
        this.open();
      } else {
        this.close(function () {});
      }
    }
  }, {
    key: 'pressEscToClose',
    value: function pressEscToClose(event) {
      if (event.keyCode === 27) {
        // esc key
        this.onClose(event);
      }
    }
  }, {
    key: 'handleHeaderIntersection',
    value: function handleHeaderIntersection(event) {
      var headerHeight = this.headerHeight;
      var actionsHeight = this.actionsHeight;
      var height = 0;
      if (headerHeight && actionsHeight) {
        height = headerHeight + actionsHeight;
      } else if (headerHeight) {
        height = headerHeight;
      }
      if (event.intersectionRatio === 0) {
        this.setState({
          scrolled: true,
          paddingTop: headerHeight,
          height: 'calc(100% - ' + height + 'px)'
        });
      } else if (event.intersectionRatio === 1) {
        this.setState({
          scrolled: false,
          paddingTop: 0,
          height: actionsHeight ? 'calc(100% - ' + actionsHeight + 'px)' : '100%'
        });
      }
    }
  }, {
    key: 'handleActionsIntersection',
    value: function handleActionsIntersection(event) {
      if (event.intersectionRatio === 0) {
        this.setState({
          actionsShadow: true
        });
      } else if (event.intersectionRatio === 1) {
        this.setState({
          actionsShadow: false
        });
      }
    }
  }, {
    key: 'handleOpen',
    value: function handleOpen() {
      if (this.state.visible) {
        if (this.props.url) {
          urlNavigation.redirect(this.props.url, this.props.title);
        }
        document.body.classList.add('andes-modal-dialog--is-open');
      } else {
        if (this.props.url) {
          urlNavigation.back(this.props.url);
        }
        document.body.classList.remove('andes-modal-dialog--is-open');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.state.visible) return null;

      var _props = this.props,
          className = _props.className,
          children = _props.children,
          actions = _props.actions,
          closeUrl = _props.closeUrl,
          showCloseButton = _props.showCloseButton,
          closable = _props.closable,
          title = _props.title,
          type = _props.type;

      var headerClass = this.state.scrolled ? 'andes-modal-dialog__header--scrolled' : '';
      var classesModal = classNames('andes-modal', 'andes-modal--' + type);

      var classesDialog = classNames('andes-modal-dialog', className, this.state.scrolled && 'andes-modal-dialog--scrolled', this.state.closing && 'andes-modal-dialog--closing');

      var classesBg = classNames('andes-modal-bg', this.state.closing && 'andes-modal-bg--closing');

      return _jsx(Portal, {
        className: classesModal
      }, void 0, showCloseButton && type === 'light' && _jsx(CloseButton, {
        url: closeUrl,
        onClose: this.onClose
      }), React.createElement(
        'div',
        { className: classesDialog, ref: this.setModal, key: 'modal-dialog' },
        _jsx('div', {
          className: 'andes-modal-dialog__wrapper'
        }, 'modal-wrapper', (title || showCloseButton) && this.state.scrolled && _jsx(Header, {
          className: headerClass,
          title: title,
          closeUrl: closeUrl,
          onClose: this.onClose,
          showCloseButton: showCloseButton && type !== 'light'
        }, 'modal-header'), _jsx('div', {
          className: 'andes-modal-dialog__container',
          style: { paddingTop: this.state.paddingTop, height: this.state.height }
        }, 'modal-container', (title || showCloseButton) && !this.state.scrolled && React.createElement(Header, {
          className: headerClass,
          title: title,
          closeUrl: closeUrl,
          onClose: this.onClose,
          showCloseButton: showCloseButton && type !== 'light',
          ref: this.setHeader,
          key: 'modal-header'
        }), _jsx(Content, {
          onHeaderScrolled: this.handleHeaderIntersection,
          onContentScrolled: this.handleActionsIntersection
        }, 'modal-content', children)), actions && type !== 'light' && React.createElement(Actions, {
          shadow: this.state.actionsShadow,
          buttonFilled: actions.buttonFilled,
          buttonTransparent: actions.buttonTransparent,
          ref: this.setActions,
          key: 'modal-actions'
        }))
      ), actions && type === 'light' && _jsx(Actions, {
        shadow: false,
        buttonFilled: actions.buttonFilled,
        buttonTransparent: actions.buttonTransparent
      }), React.createElement('div', {
        className: classesBg,
        onClick: closable && this.onClose,
        role: 'button',
        tabIndex: 0,
        ref: this.setBg,
        key: 'modal-background'
      }));
    }
  }]);

  return Modal;
}(React.PureComponent);

Modal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  className: PropTypes.string,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  showCloseButton: PropTypes.bool,
  closable: PropTypes.bool,
  closeUrl: PropTypes.string,
  type: PropTypes.oneOf(['loose', 'tight', 'full', 'light']),
  title: PropTypes.string,
  actions: PropTypes.shape({
    buttonFilled: PropTypes.shape({ type: PropTypes.func }),
    buttonTransparent: PropTypes.shape({ type: PropTypes.func })
  }),
  url: PropTypes.string
};

Modal.defaultProps = {
  className: '',
  visible: false,
  onClose: null,
  onOpen: null,
  showCloseButton: true,
  closeUrl: null,
  closable: true,
  type: 'loose',
  title: '',
  actions: null,
  url: ''
};

/**
 * Expose Component
 */
module.exports = Modal;

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Module dependencies
 */
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var classNames = __webpack_require__(2);

var Actions = function (_React$PureComponent) {
  _inherits(Actions, _React$PureComponent);

  function Actions() {
    _classCallCheck(this, Actions);

    return _possibleConstructorReturn(this, (Actions.__proto__ || Object.getPrototypeOf(Actions)).apply(this, arguments));
  }

  _createClass(Actions, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          buttonFilled = _props.buttonFilled,
          buttonTransparent = _props.buttonTransparent,
          shadow = _props.shadow;

      var classes = classNames('andes-modal-dialog__actions', shadow && 'andes-modal-dialog__actions--shadow');

      return React.createElement(
        'div',
        { className: classes, ref: function ref(elem) {
            _this2.actions = elem;
          } },
        buttonFilled,
        buttonTransparent
      );
    }
  }]);

  return Actions;
}(React.PureComponent);

Actions.propTypes = {
  shadow: PropTypes.bool,
  buttonFilled: PropTypes.shape({ type: PropTypes.func }),
  buttonTransparent: PropTypes.shape({ type: PropTypes.func })
};

Actions.defaultProps = {
  shadow: false,
  buttonFilled: null,
  buttonTransparent: null
};

/**
 * Expose Component
 */
module.exports = Actions;

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Module dependencies
 */
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var classNames = __webpack_require__(2);
var CloseButton = __webpack_require__(8);

var Header = function (_React$PureComponent) {
  _inherits(Header, _React$PureComponent);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          title = _props.title,
          closeUrl = _props.closeUrl,
          onClose = _props.onClose,
          showCloseButton = _props.showCloseButton;

      var classes = classNames(title && 'andes-modal-dialog__header', this.props.className);
      return React.createElement(
        'div',
        { className: classes, ref: function ref(elem) {
            _this2.header = elem;
          } },
        _jsx('h3', {
          className: 'andes-modal-dialog__header-title'
        }, void 0, title),
        showCloseButton && _jsx(CloseButton, {
          url: closeUrl,
          onClose: onClose
        })
      );
    }
  }]);

  return Header;
}(React.PureComponent);

Header.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  closeUrl: PropTypes.string,
  onClose: PropTypes.func,
  showCloseButton: PropTypes.bool
};

Header.defaultProps = {
  title: '',
  className: '',
  closeUrl: '',
  onClose: null,
  showCloseButton: true
};

/**
 * Expose Component
 */
module.exports = Header;

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/* eslint-disable global-require */

/**
 * Module dependencies
 */
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);

var _require = __webpack_require__(3),
    canUseDOM = _require.canUseDOM;

if (canUseDOM) {
  __webpack_require__(55);
}

var Observer = __webpack_require__(56).default;

var _ref2 = _jsx('div', {});

var _ref3 = _jsx('div', {});

var Content = function Content(_ref) {
  var children = _ref.children,
      onHeaderScrolled = _ref.onHeaderScrolled,
      onContentScrolled = _ref.onContentScrolled;
  return _jsx('div', {
    className: 'andes-modal-dialog__content'
  }, void 0, _jsx(Observer, {
    onChange: onHeaderScrolled,
    threshold: [0]
  }, void 0, _ref2), children, _jsx(Observer, {
    onChange: onContentScrolled,
    threshold: [1]
  }, void 0, _ref3));
};

Content.propTypes = {
  children: PropTypes.node.isRequired,
  onHeaderScrolled: PropTypes.func,
  onContentScrolled: PropTypes.func
};

Content.defaultProps = {
  onHeaderScrolled: null,
  onContentScrolled: null
};

/**
 * Expose Component
 */
module.exports = Content;

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

module.exports = require("intersection-observer");

/***/ }),

/***/ 56:
/***/ (function(module, exports) {

module.exports = require("@researchgate/react-intersection-observer");

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* global window */
var isLocationURL = function isLocationURL(url) {
  return window.location.href === url;
};

function addChange(action) {
  if (typeof window.history.pushState === 'function') {
    window.addEventListener('popstate', action);
  }
}

function removeChange(action) {
  if (typeof window.history.pushState === 'function') {
    window.removeEventListener('popstate', action);
  }
}

function redirect(url, title) {
  if (!isLocationURL(url)) {
    if (typeof window.history.pushState === 'function') {
      window.history.pushState(undefined, title, url);
    } else {
      window.location = url;
    }
  }
}

function back(url) {
  if (isLocationURL(url)) {
    window.history.back();
  }
}

module.exports = {
  redirect: redirect,
  back: back,
  addChange: addChange,
  removeChange: removeChange,
  isLocationURL: isLocationURL
};

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable jsx-a11y/anchor-has-content */
/**
 * Module dependencies
 */
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);

var CloseButton = function (_React$PureComponent) {
  _inherits(CloseButton, _React$PureComponent);

  function CloseButton() {
    _classCallCheck(this, CloseButton);

    return _possibleConstructorReturn(this, (CloseButton.__proto__ || Object.getPrototypeOf(CloseButton)).apply(this, arguments));
  }

  _createClass(CloseButton, [{
    key: 'render',
    value: function render() {
      return _jsx('a', {
        href: this.props.url,
        className: 'andes-modal-dialog__button-close',
        onClick: this.props.onClose
      });
    }
  }]);

  return CloseButton;
}(React.PureComponent);

CloseButton.propTypes = {
  url: PropTypes.string,
  onClose: PropTypes.func
};

CloseButton.defaultProps = {
  url: '',
  onClose: null
};

/**
 * Expose Component
 */
module.exports = CloseButton;

/***/ })

/******/ });